<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :close-on-click-modal="false" :lock-scroll="false" :before-close="closeDialog">
    <div v-loading.fullscreen="loading">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item class="login_form_item" prop="mobile">
          <el-input class="login_ipt" v-model="ruleForm.mobile" placeholder="请输入手机号" @input="setInput()"></el-input>
        </el-form-item>
        <el-form-item class="login_form_item" prop="password">
          <el-input class="login_ipt" v-model="ruleForm.password" :type="flagType" maxlength='20' placeholder="请输入密码" @input="setInput()">
            <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" @click="getFlag()" />
          </el-input>
        </el-form-item>
        <el-button class="login_btn" :disabled='disabled' type="primary" @click="submitForm('ruleForm')">登录</el-button>
        <div>
          <el-checkbox v-model='checked' label="下次自动登录" name="type">
            <div class="userText">登录或注册即代表同意 <router-link :to="{path:'/useragreement'}">用户协议</router-link> 和 <router-link :to="{path:'/privacyagreement'}">隐私政策</router-link>
            </div>
          </el-checkbox>
        </div>
        <div class="tips">
          <div>
            <span @click="godialog('forgot','login')">忘记密码</span>
            <el-divider direction="vertical"></el-divider>
            <span @click="godialog('register','login')">注册</span>
          </div>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import { login } from "@/api/public";
export default {
  name: 'login',
  components: {},
  data() {
    return {
      loading: false,
      dislogType: this.$enumInfo.dislogType,
      flagType: 'password',
      flag: false,
      checked: false,
      disabled: true,
      dialogClass: 'user',
      ruleForm: {
        mobile: '',
        password: '',
      },
      rules: {
        mobile: [
          { required: true, message: '请输入正确手机号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入正确密码', trigger: 'blur' },
        ]
      },
    }
  },
  props: {
    title: String,
    domVisible: Boolean,
  },
  created() {},
  mounted() {
    let that = this
    window.addEventListener('keydown', function(e) {
      if (!that.disabled) {
        if (e.keyCode === 13) {
          that.submitForm('ruleForm')
        }
      }
    })
    //console.log(this.$interface.SignIn)
  },
  methods: {
    // 点击快捷跳转 忘记密码 和 注册
    godialog(toval, val) {
      this.$emit('closeDialog', val, false)
      this.$emit('godialog', toval, true)
    },
    closeOther(val, bol) {
      this.dislogType[val] = bol
    },
    // 关闭弹框
    closeDialog(val) {
      this.$emit('closeDialog', 'login', false)
    },
    //密码切换状态
    getFlag() {
      this.flag = !this.flag
      this.flagType = this.flag ? 'text' : 'password' //text为显示密码；password为隐藏密码
      console.log(this.flag, this.flagType)
    },
    // 判断input是否有值
    setInput() {
      if (this.ruleForm.mobile != '' && this.ruleForm.password != '') {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    // 登入
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.disabled = true
          let data = that.ruleForm
          if (that.checked) {
            that.loading = true;
            that.$post(that.$interface.SignIn, data).then(res => {
              if (res.Result != 0) {
                login(res.Data)
                that.closeDialog()
              } else {
                that.$message.error(res.Msg);
              }
              that.loading = false;
            }).catch({})
          } else {
            that.$message.error('请同意条款');
            that.disabled = false
          }
          //login()
        }
      });
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/login.css";

</style>



// WEBPACK FOOTER //
// src/components/dialog/login.vue